import map from 'lodash/map'
import find from 'lodash/find'
import { IApplicationState } from '@Site/rootReducer'

import { createSelector } from 'reselect'

export const getTermbases = (state: IApplicationState) => state.termbases.termbases
export const getTermbasesLoading = (state: IApplicationState) => state.termbases.loadingTermbases
export const getTermbasesHasLoadedInitially = (state: IApplicationState) => state.termbases.hasLoadedInitially
export const getActiveTermbaseId = (state: IApplicationState) => state.termbases.page.activeTermbaseId
export const getModifyingTermbase = (state: IApplicationState) => state.termbases.modifying

export const getTermbaseNames = createSelector(
  [getTermbases],
  (termbases) => map(termbases, termbase => termbase.attributes.name)
)

export const getTermbaseIds = createSelector(
  [getTermbases],
  (termbases) => map(termbases, termbase => termbase.id)
)

export const getActiveTermbase = createSelector(
  [getTermbases, getActiveTermbaseId],
  (termbases, activeTermbaseId) => find(termbases, termbase => termbase.id === activeTermbaseId)
)

export const getActiveTermbaseFullnameLanguages = createSelector(
  [getActiveTermbase],
  (activeTermbase) => activeTermbase ? activeTermbase.attributes.fullnameLanguages : []
)

export const getActiveTermbaseLanguages = createSelector(
  [getActiveTermbase],
  (activeTermbase) => activeTermbase ? activeTermbase.attributes.languages : []
)
